import { CynoIcon, HumanIcon, MouseIcon } from 'static/icons';

export const SPECIES_ICONS = {
  Cyno: CynoIcon,
  Human: HumanIcon,
  Mouse: MouseIcon,
};
